<script setup lang="ts">
import type { CustomerKeyValueRow } from '@entities/customer'

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { CardAdmin } from '@shared/ui/cards'

defineOptions({
  name: 'CustomerKeyValueCard',
})

withDefaults(defineProps<{
  title: string
  rows: CustomerKeyValueRow[]
  keyTitle?: string
  valueTitle?: string
}>(), {
  keyTitle: 'Key',
  valueTitle: 'Value',
})
</script>

<template>
  <CardAdmin
    :title="title"
    fullwidth
    class="customer-key-value-card"
  >
    <AppTable
      v-if="rows.length"
      class="rounded-table"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh class="customer-key-value-card__half">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              {{ keyTitle }}
            </AppText>
          </AppTh>
          <AppTh class="customer-key-value-card__half">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              {{ valueTitle }}
            </AppText>
          </AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="row in rows"
          :key="row.key"
        >
          <AppTd class="medium">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ row.key }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText
              class="customer-key-value-card__value"
              name="body1"
              color="slate-900"
            >
              {{ row.value }}
            </AppText>
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
    <AppText
      v-else
      name="body1"
      color="slate-500"
    >
      no info
    </AppText>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./CustomerKeyValueCard.scss" />
